<template>
  <dd-input-wrapper title="Labels">
    <a-tree-select
        v-model="value"
        class="select-product-label-component"
        :tree-data="treeData"
        tree-checkable
        :show-checked-strategy="SHOW_PARENT"
        :productCategory="productCategory"
        search-placeholder="Kies labels"
    />
  </dd-input-wrapper>
</template>

<script>
import {TreeSelect} from 'ant-design-vue';
import productLabelApi from '~/api/product_label';
import store from "~/store";
import taskModule from "~/pages/components/tasks/store";
import {mapActions, mapGetters} from "vuex";

const SHOW_PARENT = TreeSelect.SHOW_PARENT;

export default {
  name: "GlobalSelectProductLabelComponent",
  props: {
    productCategory: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      treeData: [],
      SHOW_PARENT
    }
  },
  created() {
    if (!store.hasModule('task')) {
      store.registerModule('task', taskModule)
    }

    productLabelApi.getByProductCategory(
        this.productCategory,
        null,
        null,
        100
    ).then(response => {
      this.data = response.data;
      this.data.forEach((label) => {
        this.treeData.push({
          title: label.tag,
          value: label.id,
          key: label.id
        });
      });
    }).catch(error => {
      this.data = [];
    });
  },
  computed: {
    ...mapGetters('task', [
      'labelIds'
    ]),
    value: {
      get() {
        return this.labelIds;
      },
      set(labelIds) {
        this.setLabelIds(labelIds);
      }
    }
  },
  methods: {
    ...mapActions('task', [
      'setLabelIds',
    ]),
  },
};
</script>

<style scoped>
.select-product-label-component-container {
  width: 30%;
  display: unset;
  margin-left: 12px;
}

.select-product-label-component {
  min-width: 250px;
}
</style>
